// @flow strict

import css from './booking.css';

import {useWindowWidth} from 'src/components/lib/responsive.jsx';


const breakpoint = parseInt(css['v-mobileWidth']);

export function useIsMobile(): boolean {
  return useWindowWidth() <= breakpoint;
}
